module.exports = __webpack_public_path__ + "static/media/ThreadLogoWhite-1x.3bfe3990.png";